import React from 'react';
import {
  AverageContainer,
  AverageTitle,
  AverageWrapper,
  AverageSection,
  AverageInfo,
  AverageIcon,
  AverageLabel,
  AverageValue,
  AverageUnit,
} from './MonthlyAverage.styled';

interface MonthlyAverageData {
  label: string;
  value: string;
  unit: string;
  pulseValue?: string;
  pulseUnit?: string;
  mainMealLabel?: string;
  mainMealValue?: string;
  sideMealLabel?: string;
  sideMealValue?: string;
  soupMealLabel?: string;
  soupMealValue?: string;
  hydrationLabel?: string;
  hydrationValue?: string;
  hydrationUnit?: string;
  icon: React.ReactNode;
  waterIcon?: React.ReactNode;
  year: number;
  month: number;
}

interface MonthlyAverageProps {
  data: MonthlyAverageData | null;
}

/**
 * 月平均値表示コンポーネント
 * バイタルサインの種類に応じて異なるレイアウトで平均値を表示
 */
export const MonthlyAverage: React.FC<MonthlyAverageProps> = ({ data }) => {
  if (!data) return null;

  return (
    <AverageContainer>
      <AverageTitle>
        {data.year}年{data.month}月の平均
      </AverageTitle>
      {(data.mainMealValue || data.sideMealValue || data.soupMealValue || data.hydrationValue) ? (
        // 食事水分タブの場合
        <AverageWrapper>
          {(data.mainMealValue || data.sideMealValue || data.soupMealValue) && (
          <AverageSection>
            <AverageIcon>{data.icon}</AverageIcon>
            {data.mainMealValue && (
              <AverageInfo>
                <AverageLabel>{data.mainMealLabel}</AverageLabel>
                <AverageValue $isSmallFontSize={true}>{data.mainMealValue}</AverageValue>
              </AverageInfo>
            )}
            {data.sideMealValue && (
              <AverageInfo>
                <AverageLabel>{data.sideMealLabel}</AverageLabel>
                <AverageValue $isSmallFontSize={true}>{data.sideMealValue}</AverageValue>
              </AverageInfo>
            )}
            {data.soupMealValue && (
              <AverageInfo>
                <AverageLabel>{data.soupMealLabel}</AverageLabel>
                <AverageValue $isSmallFontSize={true}>{data.soupMealValue}</AverageValue>
              </AverageInfo>
            )}
          </AverageSection>
          )}
          {data.hydrationValue && (
            <AverageSection>
              <AverageIcon>{data.waterIcon}</AverageIcon>
              <AverageLabel>{data.hydrationLabel}</AverageLabel>
              <AverageInfo>
                <AverageValue>{data.hydrationValue}</AverageValue>
                <AverageUnit>{data.hydrationUnit}</AverageUnit>
              </AverageInfo>
            </AverageSection>
          )}
        </AverageWrapper>
      ) : (
        // 体温・血圧脈拍タブの場合
        <AverageWrapper>
          <AverageSection>
            <AverageIcon>{data.icon}</AverageIcon>
            <AverageLabel>{data.label}</AverageLabel>
            <AverageInfo>
              <AverageValue>{data.value}</AverageValue>
              <AverageUnit>{data.unit}</AverageUnit>
              {data.pulseValue && (
                <>
                  <AverageValue style={{ marginLeft: '4px' }}>{data.pulseValue}</AverageValue>
                  <AverageUnit>{data.pulseUnit}</AverageUnit>
                </>
              )}
            </AverageInfo>
          </AverageSection>
        </AverageWrapper>
      )}
    </AverageContainer>
  );
};

export default MonthlyAverage;
